import { Container } from "../Container/container";
import styles from "./footer.css";
import logo from "../../images/logo.png";
import instagram from "../../images/instagram.png";
import whatsapp from "../../images/whatsapp.png";
import facebook from "../../images/facebook.png";

export const Footer = () => {
    return (
        <section id="contacts" className="footer">
            <Container>
                <div className="footer__box">
                    <img className="footer__logo" src={logo} alt="" />
                    <div className="footer__block">
                    <div className="footer__adress">
                        <h2 className="footer__title" >Adress</h2>
                        <p className="footer__adresses">Svobody str. 35 Khmelnytskyi Ukraine</p>
                    </div>
                    <div className="footer__cont">
                        <h2 className="footer__title">Contact us</h2>
                        <div className="footer__contact">
                           <a href="https://www.instagram.com/"><img className="footer__contacts" src={instagram} alt="" /></a>
                            <a href="https://www.facebook.com/"><img className="footer__contacts" src={facebook} alt="" /></a>
                            <a href="https://www.whatsapp.com/"><img className="footer__contacts" src={whatsapp} alt="" /></a>
                        </div>
                    </div>
                    </div>
                </div>
            </Container>
        </section>
    )
}